<template>
  <main class="main customer_profile" role="main">
    <div class="main_con">
      <slot name="boldTextArea"></slot>
      <div class="form_wrap">
        <div class="form">
          <ul class="form_ul">
            <li class="form_li">
              <slot name="formImage"></slot>
              <div class="form_in">
                <div class="prof profile_line">
                  <div class="inner">
                    <img :src="getImageUrl" alt="" />
                  </div>
                  <input
                    ref="imageInput"
                    type="file"
                    accept="image/*"
                    hidden
                    @change="onChangeImages"
                  />
                  <button @click="onClickImageUpload">편집</button>
                </div>
              </div>
            </li>
            <li class="form_li">
              <div class="form_ttl">
                <span>닉네임</span>
              </div>
              <div class="form_in">
                <div class="inline">
                  <label class="input">
                    <input
                      type="text"
                      @input="change"
                      v-model="model.inputValue"
                      placeholder="최대 10자까지 입력해 주세요"
                    />
                  </label>
                  <button class="btn" @click="handleValidate">중복확인</button>
                </div>
                <p
                  class="valid"
                  :class="{ on: errorMsg !== null && errorMsg.length > 0 }"
                >
                  <i class="i_valid"></i>{{ errorMsg }}
                </p>
                <!--'on 추가'-->
              </div>
            </li>
          </ul>
        </div>

        <div>
          <slot name="btnWithdraw"> </slot>
        </div>
      </div>
    </div>
    <div class="btm_btn">
      <slot name="btnArea"></slot>
    </div>
  </main>
</template>

<script>
import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userActions from '@common/store/modules/user/types';
import * as getters from '@common/store/modules/user/getters';
import { showNativeToast, setProfile } from '@common/lib/common/utils';
import {
  handleFile,
  transformCoordinate,
  dataURItoBlob,
} from '@common/lib/common/imgUtils';

export default {
  name: 'Profile',
  props: {
    userProfileImg: {
      type: String,
    },
    userId: {
      type: Number,
    },
  },
  data() {
    return {
      imageUrl: require('@/assets/front/images/new/img_thumb_default.png'),
      errorMsg: null,
      checkedValidation: false,
      model: {
        inputValue: '',
      },
      file: null,
    };
  },
  created() {},
  computed: {
    getImageUrl() {
      return this.userProfileImg
        ? this.userProfileImg
        : require(`@/assets/front/images/v2/profiles/img_profile_${this.getProfileNum(
            this.userId,
          )}.png`);
    },
  },
  methods: {
    ...userMapActions([userActions.EXIST_NICKNAME]),
    change() {
      this.checkedValidation = false;
    },
    async handleValidate() {
      let regExp = /^[0-9a-zA-Z가-힣]{4,10}$/;

      if (this.model.inputValue.length == 0) {
        this.errorMsg = '닉네임을 입력 해주세요';
        this.checkedValidation = false;
        return false;
      }

      if (this.model.inputValue.length > 10) {
        this.errorMsg = '최대 10 자까지 이름을 입력 해주세요';
        this.checkedValidation = false;
        return false;
      }

      if (this.model.inputValue.length != 0) {
        this[userActions.EXIST_NICKNAME](this.model.inputValue)
          .then(() => {
            this.errorMsg = '사용가능한 닉네임입니다.';
            this.checkedValidation = true;
            showNativeToast(this.errorMsg, true);
          })
          .catch(() => {
            this.errorMsg = '이미 사용중인 닉네임 입니다';
            this.checkedValidation = false;
            showNativeToast(this.errorMsg, true);
          });
      }
      return true;
    },
    /* 프로필 사진 변경 */
    onClickImageUpload() {
      this.$refs.imageInput.click();
    },
    onChangeImages(e) {
      const maxWidth = 1024,
        quality = 0.92,
        enableCompress = true;
      this.file = null;
      if (e.target.files[0]) {
        let file = e.target.files[0];
        /*
        const binaryData = [];
        binaryData.push(this.file);
        this.imageUrl = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'application/zip' }),
        );*/
        const doSquash = file.type === 'image/jpeg';
        return handleFile(
          file,
          {
            maxWidth,
            quality,
            enableCompress,
          },
          doSquash,
        ).then(blob => {
          const blobURL = URL.createObjectURL(blob);
          const fileItem = {
            url: blobURL,
            blob,
          };
          for (let key in file) {
            if (['slice', 'webkitRelativePath'].indexOf(key) === -1) {
              fileItem[key] = file[key];
            }
          }
          this.file = fileItem;
          this.imageUrl = fileItem.url;
        });
      } else {
        this.imageUrl = require(`@/assets/front/images/v2/profiles/img_profile_${this.getProfileNum(
          this.userId,
        )}.png`);
        this.file = null;
      }
    },
    getProfileNum(userId) {
      return setProfile(userId);
    },
  },
};
</script>
<style>
.btn_withdraw {
  bottom: 50px;
}
</style>
